import { render, staticRenderFns } from "./role.vue?vue&type=template&id=0c431bc0&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"
import style0 from "./role.vue?vue&type=style&index=0&id=0c431bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c431bc0",
  null
  
)

export default component.exports